/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.multi.account.virtual.user.manager.rpc.VirtualUserChirpFrontendService
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const getVirtualUsersOnPortalRpc = {
  serviceName: 'com.hubspot.multi.account.virtual.user.manager.rpc.VirtualUserChirpFrontendService',
  rpcName: 'getVirtualUsersOnPortal',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAAW_AfyM0NPrZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};